export default "__VITE_ASSET__sJHALD73__"